import React from 'react'

interface DifferentSectionLogoProps {
  className?: string
  blinkSpeed?: string
}

export const DifferentSectionLogo: React.FC<DifferentSectionLogoProps> = ({
  className,
  blinkSpeed = '4s',
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 250 250' className={className}>
      <style>
        {`
          @keyframes blink {
            0%, 90%, 100% {
              transform: scaleY(0);
            }
            95% {
              transform: scaleY(1.1);
            }
          }

          .eye-blink {
            animation: blink ${blinkSpeed} infinite;
          }
        `}
      </style>
      <path
        d='m126.9 46.52c-58.91 0-114.7 32.44-116.9 78.08-0.15 3.61 2.63 5.16 6.78 5.06 6.36-0.15 11.13-0.73 11.28-6.9 0.86-33.04 42.02-63.84 103.7-63.84 29.3 0 58.85 10.82 72.39 25.74 5.46 6.07 10.87 14.33 13.7 21.41 1.44 3.82 5.06 3.56 9.26 2.7 6.57-1.38 8.3-3.58 6.54-8.03-12.28-30.45-48.97-54.22-101.6-54.22h-5.11z'
        fill='currentColor'
      />
      <path
        d='m134 66.29c-45.68 0-95.31 27.11-95.31 63.52 0 27.16 28.44 49.99 76.15 49.99 45.22 0 94.84-26.86 94.84-62.14 0-23.94-22.93-51.37-75.68-51.37zm-19.88 100c-33.53 0-58.16-14.28-58.16-37.56 0-25.53 31.61-50.04 79.32-50.04 32.12 0 57.56 16.13 57.56 39.31 0 11.27-7.56 25.79-26.81 35.8-13.3 7.09-29.84 12.49-51.91 12.49z'
        fill='currentColor'
      />
      <path
        d='m133.5 85.91c-36.92 0-68.12 20.7-68.12 42.11 0 16.81 20.5 30.76 49.73 30.76 33.02 0 68.62-19.98 68.62-40.7 0-18.91-20.19-32.17-50.23-32.17zm-28.4 46.9c-10.09 0-16.61-8.16-16.61-16.05 0-9.89 7.74-17.03 16.54-17.03 10.26 0 16.77 7.52 16.77 16.39 0 9.27-8.26 16.69-16.7 16.69zm38.33 9.52c-9.67 0-16.97-8.57-16.97-16.87 0-10.18 8.65-16.36 16.24-16.36 8.39 0 17.91 6.65 17.91 16.61 0 10-8.15 16.62-17.18 16.62z'
        fill='currentColor'
      />
      <path
        d='m231.1 119.8c-7.01 0-9.34 1.08-10.35 7.99-4.62 27.94-37.03 59.98-104 59.98-39.31 0-66.43-13.83-79.01-33.74-4.42-6.83-5.49-13.9-10.52-13.9-6.36 0-13.9 0.1-13.57 6.82 0.1 1.98 3.37 8.91 6.2 13.86 3.44 5.52 26 39.2 100.3 39.2 59.87 0 116.2-35.09 118.8-74.28 0.41-5.5-1.87-5.93-7.86-5.93z'
        fill='currentColor'
      />
      <ellipse
        cx='105.1'
        cy='116.27'
        rx='18'
        ry='18'
        fill='currentColor'
        className='eye-blink'
        style={{ transformOrigin: '105.1px 116.27px' }}
      />
      <ellipse
        cx='143.43'
        cy='125.71'
        rx='18'
        ry='18'
        fill='currentColor'
        className='eye-blink'
        style={{ transformOrigin: '143.43px 125.71px' }}
      />
    </svg>
  )
}
